import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';
import { isSimpleSelection, hasLinkToUrlBehaviors } from '../objects/guards';
import Shortcut from '../utils/Shortcut';

// Allows creating a link from an object on a whiteboard to an external URL
// or another object on the whiteboard (via it's URL).
class ToolLinkObjectTo extends Tool {
  static toolName = 'Link to';

  static shortcut = new Shortcut('Cmd+Option+K');

  static async action({ controller, selection }: IToolActionInput) {
    controller.actionShowUrlInputModal(selection);
  }

  // Only enabled when a single item with link behaviors is selected
  static enabled({ selection }: IToolEnabledInput) {
    return !!(
      selection &&
      !isSimpleSelection(selection) &&
      hasLinkToUrlBehaviors(selection)
    );
  }
}

export default ToolLinkObjectTo;
